<!--Copy and paste the code below into
a separate view file.
Add content in v-col component, as described below.-->
<template>  
<!-- Responsive home page layout -->
    <v-app>    
    <v-container>
        <v-row justify="center">
            <!-- Navigation Bar -->
            <v-col cols="12" class="mb-8">
                <NavBar pageTitle="Home"/>
            </v-col>

            

            <v-col  cols="12" class="mb-8">
                <AssessmentComponent 
                v-if="isVisible1" 
                v-model:isVisible="isVisible1"
                :assessment-type=assessmentType1
                ></AssessmentComponent>
            </v-col>
            <v-col  cols="12" class="mb-8">
                <AssessmentComponent 
                v-if="isVisible2" 
                v-model:isVisible="isVisible2"
                :assessment-type=assessmentType2
                ></AssessmentComponent>
            </v-col>
        </v-row>
    </v-container>
    <!-- Footer -->
    <MENDFooter></MENDFooter>
    </v-app>
</template>

<script>
// Imported components present in each page.
import MENDFooter from './MENDFooter.vue';
import NavBar from './NavBar.vue';
import AssessmentComponent from './AssessmentComponent.vue';

export default {
    name: 'App',
    components: {
    NavBar,
    MENDFooter,
    AssessmentComponent
    },
    data(){
        return{
            isVisible1: true,
            isVisible2: true,
            assessmentType1: "mood",
            assessmentType2: "anxiety"
        }
    },
    watch: {
        isVisible1(){
            this.checkVisibility();
        },
        isVisible2(){
            this.checkVisibility();
        }
    },
    methods: {
        checkVisibility(){
            if(!this.isVisible1 && !this.isVisible2){
                this.$router.push({name: "Home"});
            }
        }
    }
}
</script>

<style>
* {
    font-family: 'Montserrat';
}

.flex-box {
    display: flex;
    justify-content: center;
}
</style>
